<template>
  <span class="pb-item-details ellipsis">
    <slot />
  </span>
</template>

<style lang="scss" src="./PbItemDetails.scss" />
